import React from 'react';
import { useLanguage } from '../LanguageContext';

const About = () => {
  const { t, language } = useLanguage();
  
  return (
    <div className="fade-in">
      {/* Split Hero Section */}
      <section className="relative w-full min-h-screen flex" dir="ltr">
        {/* Left Side - Text Content with Gradient */}
        <div className="w-full lg:w-1/2 min-h-screen flex flex-col justify-center px-8 md:px-16 lg:px-20 relative z-10"
             style={{ background: 'linear-gradient(135deg, #2C3E50 0%, #4A5568 50%, #718096 100%)' }}>
          <div className={`max-w-[500px] ${language === 'ar' ? 'text-right ml-auto lg:mr-0' : 'ml-auto lg:ml-0'}`} dir={language === 'ar' ? 'rtl' : 'ltr'}>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-white leading-tight">
              {t('about.heroTitle')}
            </h1>
            <p className="text-lg md:text-xl text-gray-300 mb-10 leading-relaxed">
              {t('about.storyText')}
            </p>
            <a 
              href="#our-promise" 
              className="inline-block px-8 py-4 bg-brand-orange hover:bg-[#A34D24] text-white rounded-full font-semibold text-lg transition-all duration-300 hover:scale-105 shadow-lg"
            >
              {language === 'ar' ? 'اكتشف وعدنا' : 'Discover Our Promise'}
            </a>
          </div>
          
          {/* Scroll Indicator */}
          <div className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/60 text-3xl animate-bounce">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <polyline points="8 12 12 16 16 12"/>
            </svg>
          </div>
        </div>
        
        {/* Right Side - Image */}
        <div className="hidden lg:block w-1/2 min-h-screen relative">
          <img 
            src="https://customer-assets.emergentagent.com/job_6e808080-4424-44b5-9140-8ca297387f18/artifacts/jjhk9xfu_Entrance.png"
            alt="Harvest Education Consulting Entrance"
            className="absolute inset-0 w-full h-full object-cover"
          />
          {/* Gradient overlay from left */}
          <div className="absolute inset-0 bg-gradient-to-r from-[#4A5568] to-transparent w-1/3"></div>
          
          {/* Decorative sparkle */}
          <div className="absolute bottom-8 right-8 text-white/30">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 0L14.59 9.41L24 12L14.59 14.59L12 24L9.41 14.59L0 12L9.41 9.41L12 0Z"/>
            </svg>
          </div>
        </div>
        
        {/* Mobile Background Image */}
        <div className="lg:hidden absolute inset-0 z-0">
          <img 
            src="https://customer-assets.emergentagent.com/job_6e808080-4424-44b5-9140-8ca297387f18/artifacts/jjhk9xfu_Entrance.png"
            alt="Harvest Education Consulting Entrance"
            className="w-full h-full object-cover opacity-20"
          />
        </div>
      </section>

      {/* Core Promises - Bento Grid with Glassmorphism */}
      <section id="our-promise" className="grid grid-cols-1 md:grid-cols-3 gap-5 px-5 py-[60px] bg-brand-bg">
        <div className="bg-white/60 backdrop-blur-[10px] p-10 rounded-3xl border border-black/5">
          <h4 className="text-brand-orange mb-3 uppercase text-sm tracking-widest font-medium">{t('about.ourPromise')}</h4>
          <h3 className="text-2xl font-bold mb-3 text-brand-text">{t('about.patienceFirst')}</h3>
          <p className="text-brand-secondary leading-relaxed">
            {t('about.patienceFirstText')}
          </p>
        </div>
        
        <div className="bg-white/60 backdrop-blur-[10px] p-10 rounded-3xl border border-black/5">
          <h4 className="text-brand-orange mb-3 uppercase text-sm tracking-widest font-medium">{t('about.ourPromise')}</h4>
          <h3 className="text-2xl font-bold mb-3 text-brand-text">{t('about.totalTransparency')}</h3>
          <p className="text-brand-secondary leading-relaxed">
            {t('about.totalTransparencyText')}
          </p>
        </div>
        
        <div className="bg-white/60 backdrop-blur-[10px] p-10 rounded-3xl border border-black/5">
          <h4 className="text-brand-orange mb-3 uppercase text-sm tracking-widest font-medium">{t('about.ourPromise')}</h4>
          <h3 className="text-2xl font-bold mb-3 text-brand-text">{t('about.joyfulLearning')}</h3>
          <p className="text-brand-secondary leading-relaxed">
            {t('about.joyfulLearningText')}
          </p>
        </div>
      </section>

      {/* Amman Warmth - Family Stories */}
      <section className="py-[100px] px-[8%] bg-[#FFFDF9]">
        <div className="flex flex-col gap-20 max-w-[1000px] mx-auto">
          
          {/* Story Block 1 */}
          <div className="flex flex-col lg:flex-row items-center gap-12">
            <div className="flex-1 h-[400px] bg-cover bg-center rounded-[40px] shadow-[0_20px_40px_rgba(0,0,0,0.05)] w-full"
                 style={{ backgroundImage: "url('https://customer-assets.emergentagent.com/job_childsupport/artifacts/wtognqod_ChatGPT%20Image%20Jan%2012%2C%202026%2C%2010_54_28%20PM.png')" }}>
            </div>
            <div className="flex-1">
              <h3 className="text-[#E67E22] text-[28px] mb-4 font-bold">
                {t('home.story1Title')}
              </h3>
              <p className="text-lg text-[#4A4A4A] italic leading-[1.8]">
                {t('home.story1Text')}
                <br /><br /><strong>{t('home.story1Author')}</strong>
              </p>
            </div>
          </div>

          {/* Story Block 2 - Reversed */}
          <div className="flex flex-col lg:flex-row-reverse items-center gap-12">
            <div className="flex-1 h-[400px] bg-cover bg-center rounded-[40px] shadow-[0_20px_40px_rgba(0,0,0,0.05)] w-full"
                 style={{ backgroundImage: "url('https://customer-assets.emergentagent.com/job_harvest-special-ed/artifacts/6oqgwlrf_image.png')" }}>
            </div>
            <div className="flex-1">
              <h3 className="text-[#E67E22] text-[28px] mb-4 font-bold">
                {t('home.story2Title')}
              </h3>
              <p className="text-lg text-[#4A4A4A] italic leading-[1.8]">
                {t('home.story2Text')}
                <br /><br /><strong>{t('home.story2Author')}</strong>
              </p>
            </div>
          </div>

        </div>

        {/* Community Promise */}
        <div className="bg-[#F0F7FF] py-[60px] px-[60px] rounded-[30px] text-center mt-[100px] max-w-[1000px] mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold mb-5 text-[#2C3E50]">
            {t('home.promiseTitle')}
          </h2>
          <p className="text-lg text-[#555] max-w-[700px] mx-auto leading-relaxed">
            {t('home.promiseText')}
          </p>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-24 px-5 text-center bg-white">
        <h2 className="text-4xl md:text-5xl font-bold mb-12 text-brand-text">{t('about.teamTitle')}</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-[1000px] mx-auto mt-12">
          {/* Dr. Najlaa */}
          <div className="team-member">
            <img
              src="https://customer-assets.emergentagent.com/job_childsupport/artifacts/ycb9qbws_ChatGPT%20Image%20Jan%2013%2C%202026%2C%2003_44_01%20PM.png"
              alt={t('drNajlaa.name')}
              className="w-[150px] h-[150px] rounded-full bg-brand-blue mx-auto mb-5 object-cover"
            />
            <h5 className="text-xl font-medium mb-2 text-brand-text">{t('drNajlaa.name')}</h5>
            <p className="text-brand-secondary text-sm mb-2">{t('drNajlaa.credentials')}</p>
            <p className="text-brand-secondary text-sm">{t('about.founderTitle')}</p>
          </div>

          {/* Specialists */}
          <div className="team-member">
            <div className="w-[150px] h-[150px] rounded-full bg-brand-blue mx-auto mb-5 flex items-center justify-center">
              <span className="text-4xl">👥</span>
            </div>
            <h5 className="text-xl font-medium mb-2 text-brand-text">{t('about.specialistsTitle')}</h5>
            <p className="text-brand-secondary text-sm mb-2">{t('about.specialistsSubtitle')}</p>
            <p className="text-brand-secondary text-sm">{t('about.specialistsDesc')}</p>
          </div>
        </div>

        {/* Bio Section */}
        <div className={`max-w-[800px] mx-auto mt-16 ${language === 'ar' ? 'text-right' : 'text-left'}`}>
          <div className="bg-brand-bg p-8 md:p-12 rounded-3xl">
            <h3 className="text-2xl font-bold mb-4 text-brand-text">{t('about.aboutDrTitle')}</h3>
            <p className="text-lg text-brand-secondary leading-relaxed mb-4">
              {t('drNajlaa.bio')}
            </p>
            <div className={`flex flex-wrap gap-3 mt-6 ${language === 'ar' ? 'justify-end' : ''}`}>
              <span className="bg-white px-4 py-2 rounded-full text-sm font-medium text-brand-text border border-brand-border">
                {t('drNajlaa.experience')} {t('about.yearsExperience')}
              </span>
              <span className="bg-white px-4 py-2 rounded-full text-sm font-medium text-brand-text border border-brand-border">
                {language === 'ar' ? 'دكتوراه من الجامعة الأردنية' : 'University of Jordan PhD'}
              </span>
              <span className="bg-white px-4 py-2 rounded-full text-sm font-medium text-brand-text border border-brand-border">
                {language === 'ar' ? 'متخصصة للأعمار 3-14' : 'Ages 3-14 specialist'}
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-5 text-center bg-brand-bg">
        <h3 className="text-3xl font-bold mb-4 text-brand-text">{t('about.ctaTitle')}</h3>
        <p className="text-xl text-brand-secondary mb-8 max-w-[600px] mx-auto">
          {t('about.ctaText')}
        </p>
        <div className="flex gap-6 justify-center flex-wrap">
          <a href="/contact#book-consultation" className="text-lg text-brand-accent font-medium hover:underline">
            {t('about.bookConsultation')}
          </a>
          <a href="/services" className="text-lg text-brand-accent font-medium hover:underline">
            {t('about.explorePrograms')}
          </a>
        </div>
      </section>
    </div>
  );
};

export default About;
